/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { z } from 'zod';

/** Product Admin sub-roles — mirrors `STAFF_ROLES` in `@therapy/shared-types`. */
export const STAFF_ROLE_VALUES = [
  'PLATFORM_OWNER',
  'CUSTOMER_SUCCESS',
  'SUPPORT',
  'READONLY_AUDITOR',
] as const;

/**
 * Create a Product Admin (staff) user (Super Admin → Staff Users). The API
 * generates a one-time temporary password and returns it once; the new staff
 * member rotates it on first login. Validated identically on the FE form and
 * the API DTO.
 */
export const CreateStaffUserSchema = z.object({
  fullName: z.string().trim().min(2, 'Name is too short').max(120),
  email: z.string().trim().toLowerCase().email('Enter a valid email'),
  role: z.enum(STAFF_ROLE_VALUES),
});
export type CreateStaffUserInput = z.infer<typeof CreateStaffUserSchema>;
